<template>
    <div>
        <v-col cols="12">
            <h2 v-if="id !== UserId">{{ id ? t('users::page.title.edit_user') : t('users::page.title.new_user') }}</h2>
            <h2 v-else>
                {{ t('dms-users::page.title.my_profile') }}
            </h2>
        </v-col>
        <base-user-form :id="id"> </base-user-form>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            default: null,
        },
    },
    computed: {
        UserId() {
            return User && User.id ? User.id : false;
        },
    },
};
</script>

<style scoped></style>
